import { UseLoadingReturn } from "@/hooks/use-loading";
import useRemove from "@/hooks/use-remove";
import productImageService from "@/services/product-images.service";
import { RemoveByIdProps } from "@/types/requests.types";

export type UseRemoveProductImageReturn = {
  remove: (props: RemoveByIdProps) => Promise<void>;
} & UseLoadingReturn;

const useRemoveProductImage = (): UseRemoveProductImageReturn => {
  const { isLoading, startLoading, endLoading, loadingIcon, remove } = useRemove({
    operation: (imageId) => productImageService.delete(imageId),
  });

  return {
    isLoading,
    startLoading,
    endLoading,
    loadingIcon,
    remove,
  };
};

export default useRemoveProductImage;
